import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {filter, first, switchMap} from "rxjs/operators";
import {AiAssistantService} from "../../../../ai-assistant/service/ai-assistant.service";
import * as fromStore from "../../../../store";
import {UserSubscription} from "../../../../user/user-subscription";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../../../store";
import {IDsDropdownOption} from "../../../../shared/components/ds-dropdown/ds-dropdown-option";

@Injectable({
  providedIn: "root"
})
export class CompanyTypeResolver implements Resolve<IDsDropdownOption[]> {

  constructor(
    private readonly aiAssistantService: AiAssistantService,
    private _store: Store<DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<IDsDropdownOption[]> {
    return new Promise((resolve: Function) => {
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getUserSubscription)),
          first()
        )
        .subscribe((userSubscription: UserSubscription) => {
          userSubscription;
          this.getCompanyTypes(resolve, userSubscription);
        });
    });
  }

  private getCompanyTypes(resolve: Function, userSubscription): void {
    this.aiAssistantService.getCategories(false, !userSubscription || (userSubscription && !!userSubscription?.plan?.woocommerceService))
      .pipe(
        first(response => !!response),
      )
      .subscribe(response => {
        if (response.success) {
          const companyTypes = response.data.map(({name, title, keywords}) => (
            {label: title, value: name, keywords}
          ));
          resolve(companyTypes);
        } else {
          resolve([]);
        }
      });

  }
}
